/**
 * Legacy-slug compatibility layer for the template experience redesign.
 *
 * See docs/development/template-experience-redesign-plan.md §3.2 / §3.3.
 * When later phases rename or consolidate template slugs, old slugs are
 * registered here mapping to the current canonical slug so existing
 * tenants, links, and the provisioning saga keep working non-destructively.
 *
 * Currently empty: no template slugs have been renamed yet.
 */
import { TEMPLATE_BY_SLUG } from './template-catalog';

export const TEMPLATE_SLUG_ALIASES: Record<string, string> = Object.freeze({});

/** Resolves a possibly-legacy slug to its canonical slug. Passes through unknown slugs unchanged. */
export function resolveTemplateSlug(slug: string): string {
  return TEMPLATE_SLUG_ALIASES[slug] ?? slug;
}

/** True when the slug is either a catalog entry directly, or resolvable to one via an alias. */
export function isKnownTemplateSlug(slug: string): boolean {
  return TEMPLATE_BY_SLUG.has(resolveTemplateSlug(slug));
}
